import { render, staticRenderFns } from "./ClueDialog.vue?vue&type=template&id=56c5d370"
import script from "./ClueDialog.vue?vue&type=script&lang=js"
export * from "./ClueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports